import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from '@environment';
import { chain } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../core/authentication/authentication.service";
var MfaService = /** @class */ (function () {
    function MfaService(http, authenticationService) {
        this.http = http;
        this.authenticationService = authenticationService;
    }
    MfaService.prototype.getMfaPreferences = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_a) {
                url = environment.MORANNON_URL + "/mfa-settings";
                return [2 /*return*/, this.http.get(url, {
                        headers: { 'x-access-token': this.authenticationService.accessToken }
                    })
                        .toPromise()
                        .then(function (result) { return result['preferences']; })];
            });
        });
    };
    MfaService.prototype.regenerateToken = function (_a) {
        var password = _a.password;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, body;
            return tslib_1.__generator(this, function (_b) {
                url = environment.MORANNON_URL + "/auth/regenerate-token";
                body = { password: password };
                return [2 /*return*/, this.http.post(url, body, {
                        headers: { 'x-access-token': this.authenticationService.accessToken }
                    })
                        .toPromise()
                        .then(function (result) { return result['accessToken']; })];
            });
        });
    };
    MfaService.prototype.generateSecretToken = function (_a) {
        var accessToken = _a.accessToken;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_b) {
                url = environment.MORANNON_URL + "/mfa-settings/generate";
                return [2 /*return*/, this.http.post(url, null, {
                        headers: { 'x-access-token': accessToken }
                    })
                        .toPromise()
                        .then(function (result) { return result['secretCode']; })];
            });
        });
    };
    MfaService.prototype.verifySecretToken = function (_a) {
        var code = _a.code, accessToken = _a.accessToken;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, body;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = environment.MORANNON_URL + "/mfa-settings/verify";
                        body = { code: code };
                        return [4 /*yield*/, this.http.post(url, body, {
                                headers: { 'x-access-token': accessToken }
                            })
                                .toPromise()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MfaService.prototype.getRecoveryCodes = function (_a) {
        var accessToken = _a.accessToken;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_b) {
                url = environment.MORANNON_URL + "/recovery-codes";
                return [2 /*return*/, this.http.get(url, {
                        headers: { 'x-access-token': accessToken }
                    })
                        .toPromise()
                        .then(function (result) {
                        return chain(result['recoveryCodes'] || [])
                            .sortBy(['status', 'plainTextCode'])
                            .value();
                    })];
            });
        });
    };
    MfaService.prototype.regenerateRecoveryCodes = function (_a) {
        var accessToken = _a.accessToken;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_b) {
                url = environment.MORANNON_URL + "/recovery-codes/regenerate";
                return [2 /*return*/, this.http.post(url, null, {
                        headers: { 'x-access-token': accessToken }
                    })
                        .toPromise()
                        .then(function (result) {
                        return chain(result['recoveryCodes'] || [])
                            .sortBy(['status', 'plainTextCode'])
                            .value();
                    })];
            });
        });
    };
    MfaService.prototype.disableMfa = function (_a) {
        var accessToken = _a.accessToken;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = environment.MORANNON_URL + "/mfa-settings/disable";
                        return [4 /*yield*/, this.http.post(url, null, {
                                headers: { 'x-access-token': accessToken }
                            })
                                .toPromise()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MfaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MfaService_Factory() { return new MfaService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthenticationService)); }, token: MfaService, providedIn: "root" });
    return MfaService;
}());
export { MfaService };
